import axios from 'axios';
import { AppConstants } from '../config/AppConstants';
import store from '../store/Store';
import {
  disableLoading,
  enableLoading,
  logout,
  setPasswordExpired,
} from '../store/Reducers/UserSlice';
import { showNotification } from '../store/Reducers/NotificationSnackbarSlice';

const axiosClient = axios.create({
  baseURL: AppConstants.SERVICEURL_V2,
  timeout: 15000, // 15s
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: false, // true if using cookies/session
});

axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('ss_adm_pnl_access_token');
    console.log('Request token', token);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Optional: debug logging
    if (process.env.NODE_ENV === 'development') {
      console.log('➡️ Request:', config);
    }

    store.dispatch(enableLoading());
    return config;
  },
  (error) => Promise.reject(error),
);

axiosClient.interceptors.response.use(
  (response) => {
    store.dispatch(disableLoading());
    return response;
  },
  (error) => {
    const status = error?.response?.status;

    if (status === 403 && error?.response?.data?.header === 'Password Expired') {
      // An admin reset this user's password mid-session. The old JWT still authenticates,
      // so the backend keeps returning this 403 on every call until the password is changed.
      // Swallow it here (never settle the promise) so the calling component's own catch
      // block never fires a generic error toast — ProtectedRoute redirects to
      // /change-password as soon as passwordExpired flips true below.
      store.dispatch(setPasswordExpired(true));
      store.dispatch(disableLoading());
      return new Promise(() => {});
    }

    if (status === 401) {
      // logout / refresh token
      console.warn('Unauthorized - redirect to login');
      store.dispatch(logout());
      localStorage.clear();
      store.dispatch(
        showNotification({
          message: 'You have been logged out automatically. Please relogin.',
          severity: 'warning',
        }),
      );
    }

    if (status === 500) {
      console.error('Server error');
    }

    store.dispatch(disableLoading());
    return Promise.reject(error);
  },
);

export default axiosClient;
